import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  wrap: {
    height: 200,
    overflowY: 'auto',
    borderRadius: 0,
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    margin: '0px auto 0 auto',
  },
}));

const renderEmpty = () => {
  return (<ListItem key='empty'>
    <ListItemText disableTypography={true}
      primary={<Typography variant='subtitle1' display='block'>No canned responses</Typography>} />
  </ListItem>);
}

export default function CannedResponsesList(props) {
  const classes = useStyles();
  let items = props.items.filter((msg) => (! msg.is_greeting) );
  return (
    <Paper elevation={0} className={classes.wrap}>
      <List className={classes.root}>
        {items.length == 0 ? renderEmpty() : ''}
        {items.map( (row, idx) => {
        return (<ListItem key={`${row.id}`}
          button
          divider={idx < (props.items.length - 1)}
          selected={props.selectedId==row.id}
          onClick={() => props.onClick(row.message) }>
          <ListItemText primary={row.message} />
        </ListItem>
        )
        })}
      </List>
    </Paper>
    );
}
